module.exports = __webpack_public_path__ + "static/media/menu-equipment-blue.ea79488f.svg";